    <mat-form-field #formFieldContainer floatLabel="always" appearance="none" class="ft-checklist-main-wrap">
      <mat-label
        #labelContainer  (click)="toggleTooltip(tooltip)"
        class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">
        {{componentDefinition?.label}}
      </mat-label>
      <div class="labelToolTipContainer"
        #tooltip="matTooltip"
        matTooltip="{{componentDefinition.label}}"
        [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
      </div>
      <input matInput [hidden]="true"
            [id]="componentDefinition?.name" [name]="componentDefinition?.name"
            />     
      
    <span *ngFor='let quesOption of checkList.items.controls; let i = index;'class="checklist-wrap">
        <mat-checkbox  color="primary"  class="sc-checklist-margin"
              [name]="componentDefinition?.name + document.documentId + i" [id]="componentDefinition?.name + document.documentId + i"
              [formControl]="quesOption"
              (change)="onChange()">{{componentDefinition?.list[i]}}
        </mat-checkbox>
    </span>
  
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
